import { Component, OnInit, Input, SimpleChanges, OnChanges, ViewChild } from '@angular/core';
import { GoogleMap } from '@angular/google-maps';
import Pin from 'app/models/pin';
import { MapService } from 'app/services/map.service';
import { Observable, tap, combineLatest, filter, first, Subject } from 'rxjs';

@Component({
  selector: 'listings-map',
  templateUrl: './listings-map.component.html',
  styleUrls: ['./listings-map.component.scss']
})
export class ListingsMapComponent implements OnInit, OnChanges {

  @Input() pins: Observable<Pin[]>;
  @Input() selectedStatuses: string[];
  @Input() zoom: number = 8; //Default is 8 per Google Maps Docs
  @ViewChild('map') map:  GoogleMap; // this is the component, which contains the actual google.maps.Map instance
  constructor(private mapService: MapService) { }

  center = { lat: 39.952583, lng: -75.165222 }; // philly
  apiLoaded: Observable<boolean>;

  isComingSoonApplied: boolean;
  isActiveApplied: boolean;
  isPendingApplied: boolean;
  isActiveUnderContractApplied: boolean;
  isSoldApplied: boolean;

  mapInitialized = new Subject<boolean>();

  ngOnInit() {
    this.apiLoaded = this.mapService.initGoogleMapsApi();

    // pipe first because the tilesloaded event is fiered on every move of the map (zoom/pan), and that causes the bounds to
    // be recalculated, resetting the map.
    // we are using tilesloaded bacause the map sometimes will not be ready before the pins arrive, and then the pins are
    // rendered outside of bounds.
    combineLatest([ this.pins, this.apiLoaded, this.mapInitialized.pipe(first()), ]).pipe(
      filter(([ _, apiLoaded]) => !!apiLoaded),
      tap(([ pins ]) => {
        const bounds = new google.maps.LatLngBounds();
        pins.forEach(pin => {
          bounds.extend({ lat: pin.latitude, lng: pin.longitude });
          this.map.fitBounds(bounds);
        });
      })
    ).subscribe();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.isComingSoonApplied = this.isStatusSelected('coming_soon')
    this.isActiveApplied = this.isStatusSelected('active')
    this.isActiveUnderContractApplied = this.isStatusSelected('active_under_contract')
    this.isPendingApplied = this.isStatusSelected('pending')
    this.isSoldApplied = this.isStatusSelected('closed')
  }

  isStatusSelected(status: string) {
    return this.selectedStatuses.includes(status);
  }
}
